module.exports = __webpack_public_path__ + "static/media/cooking.7a3c44db.gif";